export const LOYALTY_ERROR_PLACEHOLDER = '-';
